
import React from 'react';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';

export const LogoutModal = ({showModal,  handleLogout, remainingTime}) => 
{
    return (
        <Modal show={showModal} >
        <div class="modal-content">
        <div class="modal-header modhead">
        <h5 class="modal-title">Time-Out Alert</h5>
        </div>
        <div class="modal-body">
     
        <div class="popup-text">
        You session is timed out since login.
        Please re-login. 
        </div>
        
        </div>
        <div class="modal-footer modhead">
        <button class="dbbtn"  onClick={handleLogout}>Logout</button>
                   </div>
            </div>

        </Modal>
    )
}

